import { ColumnFilter } from '@tanstack/react-table';
import { type MRT_RowData, type MRT_TableOptions } from 'material-react-table';

export const getDefaultMRTOptions = <TData extends MRT_RowData>(): Partial<
  MRT_TableOptions<TData>
> => ({
  layoutMode: 'grid',
  enableColumnActions: false,
  enableTopToolbar: false,
  enableStickyHeader: false,
  enableKeyboardShortcuts: false,
  enableColumnFilters: false,
  enableSorting: false,
  manualPagination: true,
  initialState: {
    density: 'compact',
  },
  muiTablePaperProps: {
    elevation: 0,
    sx: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
    },
  },
  muiTableContainerProps: {
    sx: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  muiBottomToolbarProps: {
    sx: {
      marginTop: 'auto',
      boxShadow: 'none !important',
    },
  },
  muiTableProps: ({ table }) => ({
    sx: {
      borderRadius: 0,
      paddingInline: 0,
      flex: !table.getRowCount() ? 1 : undefined,
    },
  }),
  muiTableHeadProps: ({ table }) => ({
    sx: {
      display: table.getRowCount() ? undefined : 'none',
    },
  }),
  muiTableHeadCellProps: {
    classes: {
      root: 'font-normal border-b-dividers normal-case text-sm',
    },
    sx: theme => ({
      color: `${theme.palette.text.secondary} !important`,
    }),
  },
  muiTableBodyCellProps: {
    classes: {
      root: 'border-b-dividers',
    },
    sx: theme => ({
      color: `${theme.palette.text.primary} !important`,
    }),
  },
  renderBottomToolbar: ({ table }) => {
    return !table.getRowCount() ? <div className="empty-hidden"></div> : null;
  },
  renderTopToolbar: ({ table }) => {
    return !table.getRowCount() ? <div className="empty-hidden"></div> : null;
  },
});

export type CustomColumnFilter<T> = Omit<ColumnFilter, 'value'> & {
  value?: T;
};
